import axios from 'axios';
import { environment } from '../environment/environment';

export interface TACapability {
  id: string;
  codename: string;
  name: string;
  description?: string;
}

export interface TARole {
  id: string;
  codename: string;
  name: string;
  description?: string;
  capabilities: TACapability[];
}

const ROLES_URL = `${environment.baseUrl}/ta-roles`;
const CAPABILITIES_URL = `${environment.baseUrl}/ta-capabilities`;

interface PaginatedRoleResponse {
  results?: TARole[];
}

interface PaginatedCapabilityResponse {
  results?: TACapability[];
}

async function listRoles(): Promise<TARole[]> {
  const response = await axios.get<TARole[] | PaginatedRoleResponse>(`${ROLES_URL}/`);
  const { data } = response;
  if (Array.isArray(data)) return data;
  return data.results ?? [];
}

async function getRole(id: string): Promise<TARole> {
  const response = await axios.get<TARole>(`${ROLES_URL}/${id}/`);
  return response.data;
}

async function updateRoleCapabilities(
  id: string,
  capabilityIds: string[],
): Promise<TARole> {
  const response = await axios.patch<TARole>(`${ROLES_URL}/${id}/`, {
    capability_ids: capabilityIds,
  });
  return response.data;
}

async function listCapabilities(): Promise<TACapability[]> {
  const response = await axios.get<TACapability[] | PaginatedCapabilityResponse>(
    `${CAPABILITIES_URL}/`,
  );
  const { data } = response;
  if (Array.isArray(data)) return data;
  return data.results ?? [];
}

export const taRolesApiService = {
  listRoles,
  getRole,
  updateRoleCapabilities,
  listCapabilities,
};
